import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';

export enum Drawers {
  Tasks = 'tasks-panel',
  Person = 'person',
  PolicyMatching = 'policy-matching',
  Insured = 'insured',
  RecentActivity = 'recent-activity',
  Documents = 'documents',
  Notes = EdsEntityCodes.Note,
  Contacts = 'contacts',
  Beneficiary = 'beneficiary',
  ClaimSetControl = 'claim-set-control-panel',
  AdminUsers = 'admin-users-control-panel',
  Coverages = 'coverages',
  Milestones = 'milestones',
  BenefitCalculation = 'benefit-calculation',
  Payee = 'payee',
  Transaction = 'transaction',
  PartyControl = 'party-control-panel',
  PartyAddresses = 'party-addresses',
  PartyPaymentInformation = 'party-payment-information',
  Parties = 'parties',
  Producer = 'producer',
}
